var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {},
    [
      _c(
        "header",
        { staticClass: "spaceBetween", staticStyle: { padding: "15px" } },
        [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "btn-span" }, [
            _c("span", { on: { click: _vm.login } }, [_vm._v("登录")]),
            _vm._v(" "),
            _c("span", { on: { click: _vm.register } }, [_vm._v("注册")])
          ])
        ]
      ),
      _vm._v(" "),
      _c("pswd-modify", { attrs: { noInit: true } })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "login-logo spaceLeft" }, [
      _c("img", {
        attrs: {
          src: require("@/assets/images/nylogo.png"),
          alt: "",
          srcset: "",
          height: "50"
        }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-515023be", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-515023be","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components-frame/forget-passwd.vue
// module id = tySK
// module chunks = 1